// Author panyurou
// Date 2023-11-23 20:44:09

import * as model from "@/model/sithMes/stool/SithMesStoolPurchasingGroupModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolPurchasingGroup(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .buildStore()
